const $ = require('jquery'),
    _ = require('lodash'),
    angular = require('angular');
module.exports = function (googleMapsApi, $timeout, $compile, $rootScope, storePickerService, breakpointsService) {
    return {
        restrict: 'E',
        scope: {
            mapData: '='
        },
        link(scope, elm) {

            let google,
                $map,
                map,
                mapCenter,
                markers = {};

            const infowindows = [];
            scope.storePicker = storePickerService;

            //Map functionalities

            function initialize(latlng) {
                $map = elm.find('.map-canvas')[0];

                const mapOptions = {
                    zoom: 13,
                    center: new google.maps.LatLng(latlng.Latitude, latlng.Longitude),
                    panControl: false,
                    streetViewControl: false,
                    mapTypeControl: false,
                    zoomControl: true,
                    zoomControlOptions: {
                        style: google.maps.ZoomControlStyle.SMALL,
                        position: google.maps.ControlPosition.RIGHT_BOTTOM
                    }
                };

                map = new google.maps.Map($map, mapOptions);
                mapCenter = map.getCenter();

                // Sets the map center for whenever the map bounds change (drag/resize)
                google.maps.event.addListener(map, 'bounds_changed', function () {
                    mapCenter = map.getCenter();
                });

            }

            function closeInfoWindows() {
                const windowLength = infowindows.length;
                for (let index = 0; index < windowLength; index++) {
                    infowindows[index].close();
                }
            }

            function createMarkerForStore(store, markerLabel) {
                let iconPath;
                let marker;
                const infoTemplate = '<wow-shop-time-overlay store="store"></wow-shop-time-overlay>';

                if (store.StoreNo === scope.storePicker.store.FulfilmentStoreID) {
                    iconPath = '/Images/StoreLocator/selected-pin-icon.png';
                } else {
                    iconPath = '/Images/StoreLocator/icon-pin.png';
                }
                marker = new google.maps.Marker({
                    position: new google.maps.LatLng(store.Latitude, store.Longitude),
                    title: store.Name,
                    map,
                    icon: {
                        url: iconPath,
                        origin: new google.maps.Point(1, -4)
                    },
                    animation: google.maps.Animation.DROP,
                    label: markerLabel || ' ',
                    storeInfo: store
                });

                markers[store.StoreNo] = marker;
                const element = angular.element(infoTemplate);
                const newScope = scope.$new();
                newScope.store = store;
                $compile(element)(newScope);

                $rootScope.$on('ngRepeatFinished', () => {
                    const infowindow = new google.maps.InfoWindow({
                        content: element.html()
                    });

                    infowindows.push(infowindow);

                    google.maps.event.addListener(marker, 'click', function () {
                        closeInfoWindows();
                        infowindow.open(map, marker);
                    });
                });
            }

            function resetMarkers() {
                let index = 1;
                _.forEach(markers, function (marker) {
                    if (marker.storeInfo.StoreNo !== scope.storePicker.store.FulfilmentStoreID) {
                        marker.setIcon('/Images/StoreLocator/icon-pin.png');
                        marker.setLabel('' + index + '');
                        index++;
                    }
                });
            }

            function changeMarkerIcon(marker) {
                marker.setIcon('/Images/StoreLocator/selected-pin-icon.png');
                marker.setLabel(' ');
                resetMarkers();
                mapCenter = marker.getPosition();
                map.setCenter(mapCenter);
            }

            function setStoreMarker(store, label) {
                const marker = markers[store.StoreNo];
                if (!marker) {
                    createMarkerForStore(store, label);
                } else if (store.StoreNo === scope.storePicker.store.FulfilmentStoreID) {
                    changeMarkerIcon(marker);
                }
            }

            function calculateMapCanvasSize() {
                let height;
                if (!breakpointsService.isInSmallFormat) {
                    height = $('#similar-store').innerHeight();
                } else {
                    height = 500;
                }
                $($map).css('height', height + 'px');
                $($map).css('max-height', height + 'px');
            }

            function resizeCenterMap(position) {
                calculateMapCanvasSize();
                google.maps.event.trigger(map, 'resize');
                map.setCenter(position || mapCenter);
            }

            function loadMapElement(list) {
                let markerLabel;

                if (!map) {
                    initialize(list[0]);
                } else {
                    _.forEach(markers, function (marker) {
                        marker.setMap(null);
                    });
                    markers = {};
                }

                $timeout(function () {
                    _.forEach(list, function (obj, index) {
                        if (scope.storePicker.store.FulfilmentStoreID !== obj.StoreNo) {
                            markerLabel = '' + (index + 1) + '';
                        } else {
                            markerLabel = undefined;
                        }
                        setStoreMarker(obj, markerLabel);
                    });
                    resizeCenterMap(markers[list[0].StoreNo].getPosition());
                }, 100);
            }

            function initMap(list) {
                googleMapsApi()
                .then(function (googleApi) { google = googleApi; })
                .then(function () { loadMapElement(list); });
            }

            scope.$watch('mapData', function (data) {
                if (data) {
                    initMap(data);
                }
            });
        },
        template: '<div class="map-canvas"></div>'
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shoplocator/shop-map-directive.js
 **/